import { useAtom } from "jotai";
import { useRef } from "react";
import { isMobile } from "react-device-detect";
import { animated, useSpring } from "react-spring";
import { pushGTMAnalyticsEvent } from "../../../modules/pushGTMAnalyticsEvent";
import { accordion_state, items_state } from "../../dataManagers/GlobalDataManagers";
import "./styles.scss";

export const Accordion = ({ component, children }) => {
  const [itemsState] = useAtom(items_state);
  const [accordionState, setAccordionState] = useAtom(accordion_state);
  const open = component._id === accordionState;
  const ref = useRef();

  // custom code to display rib thumbnail
  // TODO: this will need to be refactored once mutli-material is implemented
  const componentId = itemsState.activeObjs[component._id]._id === "single-material-ribs" ? "ribs-material-all" : component._id;
  // end of custom ribs code

  const accordionThumbnail = itemsState.activeObjs[componentId]?.thumbnailSrc || itemsState.activeObjs[componentId]?.imageSrc || null;

  //toggle accordion function
  let toggleHandler = (e) => {
    setAccordionState(open ? null : component._id);
    scrollIntoView();

    !open &&
      pushGTMAnalyticsEvent({
        event: "Accordion Opened - Thrill",
        id: component._id,
        displayName: component.displayName,
        page: component.category,
      });
  };


  function scrollIntoView() {
    if (component.items.length < 5 && !isMobile) return;
    setTimeout(() => {
      let buildSection = document.getElementById("BuildSection");
      if (buildSection && ref.current.offsetTop) {
        const scrollDestination = ref.current.offsetTop - 50;
        buildSection.scrollTop = scrollDestination;
      }
    }, 50);
  }

  const openAnimation = useSpring({
    from: { opacity: 1 },
    to: { opacity: 1 },
    config: { duration: 300 },
  });

  if (component.hidden) return null;

  return (
    <>
      <animated.div ref={ref} className={`${open && "active"} accordion_item  mx-auto hover_effect my-2`} style={openAnimation} onClick={toggleHandler}>
        <div className="accordion_header d-flex align-items-center">
          <div className="d-flex align-items-center justify-content-between" style={{ flex: 1 }}>
            <div className="d-flex align-items-center justify-content-center">
              <div>
                {itemsState.activeObjs[componentId]?._id?.includes("gripper") && (
                  <img className="previewThumbnail overlayTexture" src="/thrill-seekers-assets/textures/gripper-transparent.png" alt="Gripper" />
                )}
                {/* CUSTOM CODE: remove thumbnail for matching color item */}
                {accordionThumbnail && itemsState.activeObjs[componentId]._id !== "matching-color-stitching" && (
                  <img
                    className="previewThumbnail me-2"
                    src={accordionThumbnail}
                    alt="Thumbnail"
                    style={{ borderRadius: itemsState.activeObjs[componentId]?._id?.includes("color-logo") ? 0 : undefined }}
                  />
                )}
              </div>
              <h4 className="mb-0">{component.displayName.toUpperCase()}</h4>
            </div>
            {component.isNew &&
              <div className="d-flex new-label">
                <img className="new-label" src="/images/new-label.png" alt="new-label" />
              </div>
            }
          </div>
          {open ?
            <img className="expandIcon" src="/images/minus.svg" alt="expand icon" /> :
            <img className="expandIcon" src="/images/plus.svg" alt="expand icon" />
          }
        </div>
      </animated.div>
      {open && children}
    </>
  );
};
